import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "../slices/auth.slice";
import usersReducer from "../slices/users.slice";
import utilsReducer from "../slices/utils.slice";
import aiReducer from "../slices/ai.slice";
import { authApi } from "../api/auth.api";
import languageReducer from "../slices/languages.slice";
import adminReducer from "../slices/admin.slice";
import sessionSummaryReducer from "../slices/treatmentReportSummary.slice";
import paymentSessionReducer from "../slices/paymentSession.slice";
import permissionsReducer from "../slices/permissions.slice";
import periodicReportsReducer from "../slices/periodicReports.slice";
import entitlementsReducer from "../slices/entitlements.slice";
import accessControlReducer from "../slices/accessControl.slice";
import { forumApi, forumReducer } from "../forum/initSharedForum";


export const rootReducer = combineReducers({
  user: userReducer,
  users: usersReducer,
  utils: utilsReducer,
  ai: aiReducer,
  languages: languageReducer,
  [authApi.reducerPath]: authApi.reducer,
  [forumApi.reducerPath]: forumApi.reducer,
  forum: forumReducer,
  admin: adminReducer,
  treatmentReportSummary: sessionSummaryReducer,
  paymentSession: paymentSessionReducer,
  permissions: permissionsReducer,
  periodicReports: periodicReportsReducer,
  entitlements: entitlementsReducer,
  accessControl: accessControlReducer,
});

export const index = configureStore({
  reducer: rootReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      authApi.middleware,
      forumApi.middleware
      // languagesApi.middleware
    ),
  devTools: process.env.NODE_ENV === "development",
  preloadedState: undefined,
});

export default store;
